<template>
  <div>
    <div class="mt-16">
      <div class="echarts">
        <div
          id="sizebar"
          style="width: 460px; margin: 0 auto; height: 290px"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: ['contrastList'],
  components: {},
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      bottomOption: {},
    }
  },
  watch: {
    contrastList: {
      handler: function () {
        this.initBarChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.initBarChart()
  },
  methods: {
    initBarChart() {
      var myChart = this.$echarts.init(document.getElementById('sizebar'))
      this.bottomOption = {
        tooltip: {},
        xAxis: {
          type: 'category',
          data: this.contrastList.hd,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '上月活动数',
            data: this.contrastList.syhds,
            type: 'bar',
            label: {
              show: true,
              position: 'top',
            },
          },
          {
            name: '本月活动数',
            data: this.contrastList.byhds,
            type: 'bar',
            label: {
              show: true,
              position: 'top',
            },
          },
        ],
      }
      myChart.setOption(this.bottomOption)
    },
  },
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.ml-8 {
  margin-left: 8px;
}
.echarts {
  margin-top: -32px;
}
</style>
